var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"chart-row"},[_c('div',{staticClass:"chart-column",attrs:{"id":"leads-day-of-month"}}),_vm._v(" "),_c('div',{staticClass:"chart-column",attrs:{"id":"calls-day-of-month"}})])])])])
}]

export { render, staticRenderFns }